<template>
    <div>
        <touchpoint-overview-row
            class="info-row info-row-header"
        >
            <template slot="left">
                <touchpoint-overview-icon-circle class="info-circle" color="blue"/>
            </template>

            <template slot="center">
                <span class="description">{{direction}}</span>
                
                <br />

                <i class="fas fa-3x fa-long-arrow-alt-right direction-marker"/>
            </template>
            
            <template slot="right">
                <touchpoint-overview-icon-circle class="info-circle" color="green"/>
            </template>
        </touchpoint-overview-row>

        <touchpoint-info-connection-list-row
            v-for="connectionInfo in connectionsInfo"

            class="info-row"
            :key="connectionInfo.id"
            :connection-name="connectionInfo.name"

            :source-brick-name="connectionInfo.sourceBrick.name"
            :source-brick-type="connectionInfo.sourceBrick.type"
            :source-brick-config="connectionInfo.sourceBrick.config"

            :destination-brick-name="connectionInfo.destinationBrick.name"
            :destination-brick-type="connectionInfo.destinationBrick.type"
            :destination-brick-config="connectionInfo.destinationBrick.config"

            :source-conditions="filterSourceConditions(connectionInfo.conditions)"
            :destination-condition="findDestinationCondition(connectionInfo.conditions)"
        />
    </div>
</template>

<script>
    import TouchpointOverviewRow from "./TouchpointOverviewRow.vue";
    import TouchpointInfoConnectionListRow from "./TouchpointInfoConnectionListRow.vue";
    import TouchpointOverviewIconCircle from "./TouchpointOverviewIconCircle.vue";
    
    import {conditionTypes} from "@modules/JourneyBuilder/ConnectionSettings/condition-types";

    export default {
        name: 'touchpoint-info-connection-list',
        components: {
            TouchpointOverviewRow,
            TouchpointInfoConnectionListRow,
            TouchpointOverviewIconCircle
        },
        methods: {
            filterSourceConditions(conditions){
                return conditions.filter(condition => condition.type === conditionTypes.action);
            },
            findDestinationCondition(conditions){
                return conditions.find(c => c.type === conditionTypes.arrival);
            }
        },
        props: {
            connectionsInfo: {
                type: Array,
                required: true
            },
            direction: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/touchpoint-info-connection-list.scss";
</style>
